export default __webpack_public_path__ + "static/media/mascotWaving.06adb1fa.gif";